type Data = {
  filename: string
  headers: string[]
  values: unknown[][]
}

const convertToCsv = (data: Data) => {
  const header = data.headers.join(',')
  const body = data.values.map((row) => row.join(',')).join('\n')
  return `${header}\n${body}`
}

const renderCsv = (data: Data) => {
  const csv = convertToCsv(data)
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = data.filename
  link.click()
  URL.revokeObjectURL(url)
}

export default renderCsv
